import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import { AngularSplitModule } from 'angular-split';
import { DevExtremeModule } from 'projects/shared-components/devextreme.module';
import { CollarsSessionHistoryComponent } from './collars-session-history.component';
import { CollarsSessionHistoryPopupComponent } from './popup/collars-session-history-popup.component';
import { CollarsSessionHistoryGroupRowRenderer } from './collars-session-history-group-row-renderer.component';

/**
 * Collars-owned Session P&L history dialog (CR collars-session-pnl). A clone of the ETS
 * session-history dialog, re-derived under Collars (never imported from ETS-CORE). Imported by the
 * host-menu module; the popup is launched from the "Session History" host-menu item.
 */
@NgModule({
   imports: [
      CommonModule,
      AngularSplitModule,
      AgGridModule.withComponents([
         CollarsSessionHistoryGroupRowRenderer
      ]),
      DevExtremeModule
   ],
   exports: [
      CollarsSessionHistoryPopupComponent
   ],
   declarations: [
      CollarsSessionHistoryComponent,
      CollarsSessionHistoryPopupComponent,
      CollarsSessionHistoryGroupRowRenderer
   ]
})
export class CollarsSessionHistoryModule { }
